import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/home/Index.vue'),
    },
    {
      path: '/about',
      name: 'About me',
      component: () => import('@/views/about/Index.vue'),
    },
    {
      path: '/portfolio',
      name: 'Portfolio',
      component: () => import('@/views/portfolio/Index.vue'),
    },
    {
      path: '/services',
      name: 'Services',
      component: () => import('@/views/services/Index.vue'),
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('@/views/contact/Index.vue'),
    },
    {
      path: '*',
      name: 'Error',
      component: () => import('@/views/Error.vue'),
    },
  ],
})
